import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useStores from "@hooks/useStores";

import { Alert, AlertTitle } from "@material-ui/lab";
import WbIncandescentOutlinedIcon from "@material-ui/icons/WbIncandescentOutlined"; // lightbulb
import OfflineBoltOutlinedIcon from "@material-ui/icons/OfflineBoltOutlined"; // bolt
import FormatQuoteOutlinedIcon from "@material-ui/icons/FormatQuoteOutlined"; // quote
import FunctionsOutlinedIcon from "@material-ui/icons/FunctionsOutlined"; // formula
import MusicNoteOutlinedIcon from "@material-ui/icons/MusicNoteOutlined"; // music
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined"; // money
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";

import Box from "@material-ui/core/Box";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import ContentMath from "./ContentMath";
import ContentImage from "./ContentImage";
import ContentAsset from "./ContentAsset";

const ContentAlert = ({
	severity,
	title,
	iconAlias: icon,
	message,
	CustomMessage,
}) => {
	const classes = useStyles("Content");
	const { contentStore: store } = useStores();

	const options = {
		renderNode: {
			[INLINES.HYPERLINK]: (node, children) => {
				return (
					<a href={`${node.data.uri}`} target="_blank">
						{children}
					</a>
				);
			},
			[BLOCKS.EMBEDDED_ENTRY]: (node) => {
				const entry = store.findLinkedEntity(node, message.links?.entries);
				if (!entry) return;
				switch (entry.__typename) {
					case "Math":
						return <ContentMath {...entry} />;
					case "Image":
						return <ContentImage {...entry} />;
				}
			},
			[INLINES.EMBEDDED_ENTRY]: (node) => {
				const entry = store.findLinkedEntity(node, message.links?.entries);
				if (!entry) return;
				switch (entry.__typename) {
					case "Math":
						return <ContentMath {...entry} />;
				}
			},
			[BLOCKS.EMBEDDED_ASSET]: (node) => {
				const asset = store.findLinkedEntity(node, message.links?.assets);
				if (!asset) return;
				return <ContentAsset {...asset} />;
			},
			[INLINES.ENTRY_HYPERLINK]: (node, children) => {
				const entry = store.findLinkedEntity(node, message.links?.entries);
				if (!entry) return;
				return (
					<a href={`${entry.folder}${entry.slug}`} target="_blank">
						{children}
					</a>
				);
			},
		},
	};

	const Message = () =>
		CustomMessage || documentToReactComponents(message.json, options);

	return (
		<React.Fragment>
			<Box my={8}>
				{icon && icon != "default" ? (
					<Alert
						severity={severity ? severity : "info"}
						icon={
							icon === "default" ? (
								true
							) : (icon === "lightbulb") === true ? (
								<WbIncandescentOutlinedIcon fontSize="inherit" />
							) : (icon === "bolt") === true ? (
								<OfflineBoltOutlinedIcon fontSize="inherit" />
							) : (icon === "quote") === true ? (
								<FormatQuoteOutlinedIcon fontSize="inherit" />
							) : (icon === "formula") === true ? (
								<FunctionsOutlinedIcon fontSize="inherit" />
							) : (icon === "music") === true ? (
								<MusicNoteOutlinedIcon fontSize="inherit" />
							) : (icon === "money") === true ? (
								<MonetizationOnOutlinedIcon fontSize="inherit" />
							) : (icon === "question") === true ? (
								<HelpOutlineOutlinedIcon fontSize="inherit" />
							) : (icon === "none") === true ? (
								false
							) : (
								false
							)
						}
						classes={{ message: classes.alertMessage }}
					>
						{title && <AlertTitle>{title}</AlertTitle>}
						<Message />
					</Alert>
				) : (
					<Alert
						severity={severity ? severity : "info"}
						classes={{ message: classes.alertMessage }}
					>
						{title && <AlertTitle>{title}</AlertTitle>}
						<Message />
					</Alert>
				)}
			</Box>
		</React.Fragment>
	);
};

ContentAlert.propTypes = {};
export default ContentAlert;
